export default {
    add_server_success: '追加された監視サーバー', //'Đã thêm server giám sát'
    update_server_success: '更新を完了しました。',  // cập nhật server thành công
    server_paused: 'サーバーが監視を一時停止しました', // server đã tạm dừng

    // contact
    titleContact: 'アラート通知先', // tiêu đề trang liên hệ
    btnAddContact: '連絡先を追加', // thêm địa chỉ liên hệ
    titleColumnContactName: '通知先名', // tiêu đề cột đầu tiên header bảng liên hệ
    titleColumnContactEmail: '通知先メールアドレス', // tiêu đề cột thứ 2 header bảng liên hệ
    btnTestEmail: 'テスト送信', // gửi email test
    titleCreateContact: '監視アラート通知先追加', // tiêu đề trang tạo liên hệ
    formContactName: '通知先名', // tiêu đề input tên liên hệ
    requireFormContactName: '通知先名をご入力ください', // text báo lỗi chưa nhập tên
    formContactEmail: '通知先メールアドレス', // tiêu đề input email liên hệ
    requireFormContactEmail: '通知先メールアドレスをご入力ください', // text báo lỗi chưa nhập email liên hệ
    btnSaveContact: '保存', // tên nút lưu liên hệ
    btnCancelContact: 'Cancel', // tên nút cancel edit form
    updateContactSuccess: '通知先名更新しました。', // message khi liên hệ update thành công
    createContactSuccess: '通知先名作成した。', // message khi liên hệ tạo thành công
    sendMailSuccess: 'メールを送信しました。',
    required: '必須', // required text
    btnRemoveContact: '削除',
    removeContactSuccess: '通知先名削除された。',

    // menu
    menuUser: 'ユーザー',
    
    // user
    btnEditUser: '編集',
    titleUser: 'ユーザー',
    btnAddUser: 'ユーザーを追加',
    titleCreateUser: 'ユーザー',
    titleColumnUserName: 'ユーザー',
    formUserName: 'ユーザー',
    requireFormUserName: 'ユーザーをご入力ください。', //
    formUserLogin: 'ログイン ID',
    requireFormUserLogin: 'ログイン IDをご入力ください。',
    formUserPassword: 'パスワード',
    requireFormUserPassword: 'パスワードをご入力ください。',
    formUserRePassword: '確認用パスワード',
    requireFormUserRePassword: '確認用パスワードをご入力ください。',
    btnSaveUser: 'Save',
    passwordNotMatch: 'パスワードと確認用パスワードを同じにご入力ください。',
    updatePassword: 'パスワードを編集',
    updateUserSuccess: '更新を完了しました。',

    //server
    backButton: '監視サーバー一覧に戻る',
    editButton: '監視設定編集',
    checkboxRepeatSendNotification: 'エラーがまだ修正されない場合、再度通知を有効にする。',
    titleNotification: 'アラート通知一覧',
    titleColumnAlertDate: '送った日時',
    titleColumnAlertServer: '監視設定',
    titleColumnStates: '内容',
    errorState: '項目'
};